import { FF_SUBSCRIPTION_DISCOUNT_PROMO } from '@/consts/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/**
 * Whether the first-month subscription-discount campaign should be advertised.
 *
 * Display only — the server decides independently whether a checkout is actually discounted, and it
 * additionally requires a matching `discounts` row that the client cannot see. The flag payload
 * carries the campaign id and rate for the server; the client advertises fixed per-plan amounts
 * instead, because the campaign is not a flat rate across plans.
 */
export const useIsSubscriptionDiscountActive = (): boolean => {
  const { value } = useFeatureFlag(FF_SUBSCRIPTION_DISCOUNT_PROMO);
  return value === true;
};
